// Bulk updates replace writable values: retain unchanged writable fields while
// excluding readable-only metadata. Use only for the loaded reconfiguration form.
export default function reconfigurationAttributes(product) {
    if (!Array.isArray(product.writable_attributes)) {
        throw new Error('Product permissions are unavailable. Reload the product before saving.');
    }
    const writable = new Set(product.writable_attributes);
    const serialize = attributes => Object.entries(attributes || {})
        .filter(([name]) => writable.has(name))
        .map(([name, value]) => `${name}~${value ?? ''}`).join('|');
    return {
        attributes_string: serialize(product.attribute_store),
        detail_attributes_string: Object.entries(product.detail_attributes_hash_by_cfg_item_id || {})
            .filter(([id]) => product.cfg_item_ids.map(String).includes(String(id)))
            .map(([id, attributes]) => `${id}=>${serialize(attributes)}`).join('!;!')
    };
}
